// modules
import Footer from "@components/footer";
import React from "react";
import Props from "./props";

// style
import "./style.css";

const Box = (props: Props) => {
  // Attributes
  const { type, children } = props;

  // Methods
  function findClassName() {
    let className = "box";

    if (type) {
      className += ` ${type}`;
    }

    if (type === "boxinside") {
      className = `${type}`;
    }

    return className;
  }

  // Render
  return(
    <div className={findClassName()}>
      {children}
      {/* {type ? "" : <Footer />} */}
    </div>
  );
};

export default Box;
